import React, { useEffect } from "react";
import "./What_We_Do.css";
import White_Btn from "../../common/common_btn/white_btn/White_Btn";
import { useNavigate } from "react-router-dom";
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AllSocialLink } from "../../../features/admin/footer/Slice";

const What_We_Do = () => {

  // const social_icons = [
  //   faYoutube,
  //   faLinkedinIn,
  //   faFacebookF,
  //   faTwitter,
  //   faInstagram,
  // ];

  const socialIconMap = {
    youtube: faYoutube,
    linkedin: faLinkedinIn,
    facebook: faFacebookF,
    twitter: faTwitter,
    instagram: faInstagram,
  };


  const all_social_links = useSelector((state) => state.footer.all_social_links);


  const combinedSocialLinks = all_social_links?.map(item => ({
    ...item,
    icon: socialIconMap[item?.name?.toLowerCase()] || null,
  }));


  // console.log({ combinedSocialLinks });



  const navigate = useNavigate();

  const dispatch = useDispatch();
  useEffect(() => {

    dispatch(AllSocialLink());

  }, [dispatch])

  return (
    <section className="What_We_Do">
      <div className="container">
        <div className="content_div">
          <div className="left_img_holder">
            <img
              src="/assets/images/vission_mission/what_we_do/sticks.png"
              className="left_sticks"
            />
          </div>

          <div className="right_img_holder">
            <img
              src="/assets/images/vission_mission/what_we_do/sticks.png"
              className="rigth_sticks"
            />
          </div>

          <div className="middle_content_div">
            <div className="text_holder">
              <p className="section_text">What we do</p>
              <p className="descn_text">
                <b>
                  At Om Tapovan Ashram, we open pathways to profound divine
                  consciousness.{" "}
                </b>
                Our methods are both unique & holistic, designed for a true
                connection.
              </p>

              <p className="descn_text">
                Our core activities revolve around the harmonious integration of
                <b>
                  Spirituality, Science, and Prana to achieve a world that is
                  Gyanmay, Dhyanmay, and Pranmay.
                </b>
              </p>
            </div>

            <div className="footer_part">
              <div className="white_btn_holder">
                <White_Btn btnText={"About Us"} onClick={() => navigate('/about-us')} />
              </div>

              <div className="social_icon_div">
                {combinedSocialLinks?.map((data, item) => {
                  return (
                    <div className="social_icon_box">
                      <Link target="_blank" to={data.url}><FontAwesomeIcon icon={data.icon} className="social_icon" /></Link>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default What_We_Do;
